import { USER_ROLES } from "./constants";

/**
 * Role-based redirection configuration for users who just signed in.
 * Upper items have precedence over lower items.
 */
export const ROLE_CONFIG = {
  [USER_ROLES.SUPER_ADMIN]: "/users",
  [USER_ROLES.CUSTOMER_SUPPORT]: "/users",
} as const;
